import { DropdownMenuCheckboxItem } from './dropdown-menu-checkbox-item.js';
import { DropdownMenuContent } from './dropdown-menu-content.js';
import { DropdownMenuGroup } from './dropdown-menu-group.js';
import { DropdownMenuHeader } from './dropdown-menu-header.js';
import { DropdownMenuItem } from './dropdown-menu-item.js';
import { DropdownMenuRadioGroup } from './dropdown-menu-radio-group.js';
import { DropdownMenuRadioSelectItem } from './dropdown-menu-radio-select-item.js';
import { DropdownMenuRoot } from './dropdown-menu-root.js';
import { DropdownMenuSeparator } from './dropdown-menu-separator.js';
import { DropdownMenuSubMenuContent } from './dropdown-menu-sub-menu-content.js';
import { DropdownMenuSubMenuRoot } from './dropdown-menu-sub-menu-root.js';
import { DropdownMenuSubMenuTrigger } from './dropdown-menu-sub-menu-trigger.js';
import { DropdownMenuTrigger } from './dropdown-menu-trigger.js';
var DropdownMenu = {
  Root: DropdownMenuRoot,
  Group: DropdownMenuGroup,
  RadioGroup: DropdownMenuRadioGroup,
  Trigger: DropdownMenuTrigger,
  RadioSelectItem: DropdownMenuRadioSelectItem,
  CheckboxItem: DropdownMenuCheckboxItem,
  Content: DropdownMenuContent,
  Item: DropdownMenuItem,
  Separator: DropdownMenuSeparator,
  SubMenuRoot: DropdownMenuSubMenuRoot,
  SubMenuTrigger: DropdownMenuSubMenuTrigger,
  SubMenuContent: DropdownMenuSubMenuContent,
  Header: DropdownMenuHeader
};
export { DropdownMenu };